import { render } from "./PhotoCaptureComponent.vue?vue&type=template&id=618ae632"
import script from "./PhotoCaptureComponent.vue?vue&type=script&lang=js"
export * from "./PhotoCaptureComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__